import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Modal, notification, Spin } from 'antd'
import { downloadExamineeBatch, findExamCertificateTemplate, getExamineeCertificateInfoBatch } from '../../common/request'
import { useSelector } from 'react-redux'
import ResponseCode from '../../common/response-code'
import { downloadFile } from '../../plugins/utils'
import { generateAdmissionTicket } from '../../components/examinee/plugins/GenerateAdmissionTicket'

const PrintAdmissionTicketModal = forwardRef((props, ref) => {
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const envInfo = useSelector(state => state.env.envInfo)
   const[modalVisible, setModalVisible] = useState(false)
  const [loadingText, setLoadingText] = useState('加载中...')
  const [loading, setLoading] = useState(true)
  const [watermarkConfig, setWatermarkConfig] = useState([])

  useEffect(() => {
    if (selectedExam.baseConfig) {
      setWatermarkConfig(JSON.parse(selectedExam.baseConfig).watermarkConfig || [])
    }
  }, [selectedExam])

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = (examineeItems) => {
    setModalVisible(true)
    getExamApplyFieldTemplateAction(examineeItems)
  }

  const getExamApplyFieldTemplateAction = (examineeList) => {
    setLoadingText('正在查询笔试准考证模板信息...')
    setLoading(true)
    Promise.all([
      getExamineeCertificateInfoBatch({
        examId: selectedExam.id,
        idCards: examineeList.map(item => item.idCard)
      }),
      findExamCertificateTemplate({ examId: selectedExam.id })
    ]).then(([infoRes, templateInfoRes]) => {
      if (templateInfoRes.code !== ResponseCode.success) {
        Modal.error({
          title: '错误',
          content: '笔试准考证模板信息查询失败'
        })
        return
      }

      if (infoRes.code !== ResponseCode.success) {
        Modal.error({
          title: '错误',
          content: '考生笔试准考证信息查询失败'
        })
        return
      }

      generateCertificateFile(infoRes.data, templateInfoRes.data)
    })
  }

  const generateCertificateFile = (certificateInfoList, templateInfo) => {
    setLoadingText('正在生成考生笔试准考证信息...')
    const tableList = certificateInfoList.map(certificateInfo => {
      return {
        html: generateAdmissionTicket(templateInfo.template, templateInfo.fieldSet, certificateInfo, envInfo),
        examineesName: certificateInfo.name,
        applyNo: certificateInfo.idCard
      }
    })

    downloadExamineeBatch({
      tableList: tableList,
      fileType: 'CERTIFICATE',
      waterMark:  watermarkConfig.includes('examCertificate') ? selectedExam.name : ''
    }).then((res) => {
      downloadFile(res, 'zip', '考生笔试准考证').catch(err => {
        console.error(err)
        Modal.error({
          title: '错误',
          content: err,
        })
      }).finally(() => {
        setLoadingText('文件生成成功')
      })
      setTimeout(() => {
        hideModal()
      }, 500)
      notification.success({
        message: '下载成功'
      })
    }).catch(err => {
      console.error(err)
      Modal.error({
        title: '错误',
        centered: true,
        content: '网络错误，生成文件失败，请稍后尝试'
      })
    })
  }

  const hideModal = () => {
     setModalVisible(false)
  }

  return (<>
    <Modal
      title={ '批量打印笔试准考证' }
      open={ modalVisible }
      closable={ false }
      footer={ null }
    >
      <Spin spinning={ loading } tip={ loadingText }>
        <div style={ { height: '500px' } }></div>
      </Spin>
    </Modal>
  </>)
})

export default PrintAdmissionTicketModal
